module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.9f79d87fa2081ac3b2ad.js");
}
